/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  DeactivateUsersByOrganizationIdMutationRequest,
  DeactivateUsersByOrganizationIdMutationResponse,
} from "../types/DeactivateUsersByOrganizationId.ts"

export const deactivateUsersByOrganizationIdMutationKey = () =>
  [{ url: "/v1/user/deactivate-users-by-organization-id" }] as const

export type DeactivateUsersByOrganizationIdMutationKey = ReturnType<
  typeof deactivateUsersByOrganizationIdMutationKey
>

/**
 * @summary Deactivate users by organization id
 * {@link /v1/user/deactivate-users-by-organization-id}
 */
export async function deactivateUsersByOrganizationId(
  data: DeactivateUsersByOrganizationIdMutationRequest,
  config: Partial<
    RequestConfig<DeactivateUsersByOrganizationIdMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    DeactivateUsersByOrganizationIdMutationResponse,
    ResponseErrorConfig<Error>,
    DeactivateUsersByOrganizationIdMutationRequest
  >({
    method: "PUT",
    url: `/v1/user/deactivate-users-by-organization-id`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function deactivateUsersByOrganizationIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<DeactivateUsersByOrganizationIdMutationRequest>
  > & { client?: Client } = {}
) {
  const mutationKey = deactivateUsersByOrganizationIdMutationKey()
  return mutationOptions<
    ResponseConfig<DeactivateUsersByOrganizationIdMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeactivateUsersByOrganizationIdMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return deactivateUsersByOrganizationId(data, config)
    },
  })
}

/**
 * @summary Deactivate users by organization id
 * {@link /v1/user/deactivate-users-by-organization-id}
 */
export function useDeactivateUsersByOrganizationId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeactivateUsersByOrganizationIdMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: DeactivateUsersByOrganizationIdMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<DeactivateUsersByOrganizationIdMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? deactivateUsersByOrganizationIdMutationKey()

  const baseOptions = deactivateUsersByOrganizationIdMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DeactivateUsersByOrganizationIdMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeactivateUsersByOrganizationIdMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<DeactivateUsersByOrganizationIdMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeactivateUsersByOrganizationIdMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeactivateUsersByOrganizationIdMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeactivateUsersByOrganizationIdMutationRequest },
    TContext
  >
}
